import { createContext } from "react";

const AddProductContext = createContext();

export default AddProductContext;
